var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3101 0.75H-7.30859V24.75H31.3101V0.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3101 22.7949H-7.30859V24.7492H31.3101V22.7949Z",
    fill: "#F32403"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3101 18.7305H-7.30859V20.6847H31.3101V18.7305Z",
    fill: "#F32403"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3101 14.9785H-7.30859V16.9329H31.3101V14.9785Z",
    fill: "#F32403"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3101 11.4609H-7.30859V13.4152H31.3101V11.4609Z",
    fill: "#F32403"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3101 7.70703H-7.30859V9.66116H31.3101V7.70703Z",
    fill: "#F32403"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3101 4.0332H-7.30859V5.98747H31.3101V4.0332Z",
    fill: "#F32403"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3101 0.75H-7.30859V2.7044H31.3101V0.75Z",
    fill: "#F32403"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42114 0.75H-7.30859V13.4145H9.42114V0.75Z",
    fill: "#011173"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.309634 1.54688L-0.138301 1.89474L0.245832 1.95048L-0.0319006 2.22114L0.0334322 2.60341L-0.309634 2.42287L-0.653368 2.60341L-0.587501 2.22114L-0.865234 1.95048L-0.481368 1.89474L-0.309634 1.54688Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4207 1.54688L2.59217 1.89474L2.9763 1.95048L2.69843 2.22114L2.7639 2.60341L2.4207 2.42287L2.0775 2.60341L2.14297 2.22114L1.86523 1.95048L2.24883 1.89474L2.4207 1.54688Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1513 1.54688L5.32264 1.89474L5.70677 1.95048L5.42904 2.22114L5.4945 2.60341L5.1513 2.42287L4.80797 2.60341L4.87344 2.22114L4.5957 1.95048L4.97944 1.89474L5.1513 1.54688Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87982 1.54688L8.05168 1.89474L8.43528 1.95048L8.15755 2.22114L8.22302 2.60341L7.87982 2.42287L7.53662 2.60341L7.60208 2.22114L7.32422 1.95048L7.70808 1.89474L7.87982 1.54688Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17669 2.79883L1.34803 3.14656L1.73203 3.20229L1.45429 3.47309L1.51976 3.85523L1.17669 3.67483L0.83296 3.85523L0.898827 3.47309L0.621094 3.20229L1.00483 3.14656L1.17669 2.79883Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90703 2.79883L4.07836 3.14656L4.4625 3.20229L4.18476 3.47309L4.25023 3.85523L3.90703 3.67483L3.56343 3.85523L3.6293 3.47309L3.35156 3.20229L3.73516 3.14656L3.90703 2.79883Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6375 2.79883L6.80883 3.14656L7.1931 3.20229L6.91536 3.47309L6.98083 3.85523L6.6375 3.67483L6.2943 3.85523L6.35976 3.47309L6.08203 3.20229L6.46576 3.14656L6.6375 2.79883Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17669 5.30273L1.34803 5.6506L1.73203 5.70633L1.45429 5.97713L1.51976 6.3594L1.17669 6.17887L0.83296 6.3594L0.898827 5.97713L0.621094 5.70633L1.00483 5.6506L1.17669 5.30273Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90703 5.30273L4.07836 5.6506L4.4625 5.70633L4.18476 5.97713L4.25023 6.3594L3.90703 6.17887L3.56343 6.3594L3.6293 5.97713L3.35156 5.70633L3.73516 5.6506L3.90703 5.30273Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6375 5.30273L6.80883 5.6506L7.1931 5.70633L6.91536 5.97713L6.98083 6.3594L6.6375 6.17887L6.2943 6.3594L6.35976 5.97713L6.08203 5.70633L6.46576 5.6506L6.6375 5.30273Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17669 7.80469L1.34803 8.15229L1.73203 8.20829L1.45429 8.47909L1.51976 8.86122L1.17669 8.68082L0.83296 8.86122L0.898827 8.47909L0.621094 8.20829L1.00483 8.15229L1.17669 7.80469Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90703 7.80469L4.07836 8.15229L4.4625 8.20829L4.18476 8.47909L4.25023 8.86122L3.90703 8.68082L3.56343 8.86122L3.6293 8.47909L3.35156 8.20829L3.73516 8.15229L3.90703 7.80469Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6375 7.80469L6.80883 8.15229L7.1931 8.20829L6.91536 8.47909L6.98083 8.86122L6.6375 8.68082L6.2943 8.86122L6.35976 8.47909L6.08203 8.20829L6.46576 8.15229L6.6375 7.80469Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17669 10.3086L1.34803 10.6565L1.73203 10.7122L1.45429 10.9827L1.51976 11.3653L1.17669 11.1845L0.83296 11.3653L0.898827 10.9827L0.621094 10.7122L1.00483 10.6565L1.17669 10.3086Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90703 10.3086L4.07836 10.6565L4.4625 10.7122L4.18476 10.9827L4.25023 11.3653L3.90703 11.1845L3.56343 11.3653L3.6293 10.9827L3.35156 10.7122L3.73516 10.6565L3.90703 10.3086Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6375 10.3086L6.80883 10.6565L7.1931 10.7122L6.91536 10.9827L6.98083 11.3653L6.6375 11.1845L6.2943 11.3653L6.35976 10.9827L6.08203 10.7122L6.46576 10.6565L6.6375 10.3086Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.309634 4.05078L-0.138301 4.39865L0.245832 4.45425L-0.0319006 4.72505L0.0334322 5.10731L-0.309634 4.92678L-0.653368 5.10731L-0.587501 4.72505L-0.865234 4.45425L-0.481368 4.39865L-0.309634 4.05078Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4207 4.05078L2.59217 4.39865L2.9763 4.45425L2.69843 4.72505L2.7639 5.10731L2.4207 4.92678L2.0775 5.10731L2.14297 4.72505L1.86523 4.45425L2.24883 4.39865L2.4207 4.05078Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1513 4.05078L5.32264 4.39865L5.70677 4.45425L5.42904 4.72505L5.4945 5.10731L5.1513 4.92678L4.80797 5.10731L4.87344 4.72505L4.5957 4.45425L4.97944 4.39865L5.1513 4.05078Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87982 4.05078L8.05168 4.39865L8.43528 4.45425L8.15755 4.72505L8.22302 5.10731L7.87982 4.92678L7.53662 5.10731L7.60208 4.72505L7.32422 4.45425L7.70808 4.39865L7.87982 4.05078Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.309634 6.55273L-0.138301 6.90047L0.245832 6.9562L-0.0319006 7.227L0.0334322 7.60927L-0.309634 7.42873L-0.653368 7.60927L-0.587501 7.227L-0.865234 6.9562L-0.481368 6.90047L-0.309634 6.55273Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4207 6.55273L2.59217 6.90047L2.9763 6.9562L2.69843 7.227L2.7639 7.60927L2.4207 7.42873L2.0775 7.60927L2.14297 7.227L1.86523 6.9562L2.24883 6.90047L2.4207 6.55273Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1513 6.55273L5.32264 6.90047L5.70677 6.9562L5.42904 7.227L5.4945 7.60927L5.1513 7.42873L4.80797 7.60927L4.87344 7.227L4.5957 6.9562L4.97944 6.90047L5.1513 6.55273Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87982 6.55273L8.05168 6.90047L8.43528 6.9562L8.15755 7.227L8.22302 7.60927L7.87982 7.42873L7.53662 7.60927L7.60208 7.227L7.32422 6.9562L7.70808 6.90047L7.87982 6.55273Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.309634 9.05664L-0.138301 9.40424L0.245832 9.46024L-0.0319006 9.73077L0.0334322 10.113L-0.309634 9.93251L-0.653368 10.113L-0.587501 9.73077L-0.865234 9.46024L-0.481368 9.40424L-0.309634 9.05664Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4207 9.05664L2.59217 9.40424L2.9763 9.46024L2.69843 9.73077L2.7639 10.113L2.4207 9.93251L2.0775 10.113L2.14297 9.73077L1.86523 9.46024L2.24883 9.40424L2.4207 9.05664Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1513 9.05664L5.32264 9.40424L5.70677 9.46024L5.42904 9.73077L5.4945 10.113L5.1513 9.93251L4.80797 10.113L4.87344 9.73077L4.5957 9.46024L4.97944 9.40424L5.1513 9.05664Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87982 9.05664L8.05168 9.40424L8.43528 9.46024L8.15755 9.73077L8.22302 10.113L7.87982 9.93251L7.53662 10.113L7.60208 9.73077L7.32422 9.46024L7.70808 9.40424L7.87982 9.05664Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.309634 11.5605L-0.138301 11.9084L0.245832 11.964L-0.0319006 12.2351L0.0334322 12.6171L-0.309634 12.4368L-0.653368 12.6171L-0.587501 12.2351L-0.865234 11.964L-0.481368 11.9084L-0.309634 11.5605Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4207 11.5605L2.59217 11.9084L2.9763 11.964L2.69843 12.2351L2.7639 12.6171L2.4207 12.4368L2.0775 12.6171L2.14297 12.2351L1.86523 11.964L2.24883 11.9084L2.4207 11.5605Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1513 11.5605L5.32264 11.9084L5.70677 11.964L5.42904 12.2351L5.4945 12.6171L5.1513 12.4368L4.80797 12.6171L4.87344 12.2351L4.5957 11.964L4.97944 11.9084L5.1513 11.5605Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87982 11.5605L8.05168 11.9084L8.43528 11.964L8.15755 12.2351L8.22302 12.6171L7.87982 12.4368L7.53662 12.6171L7.60208 12.2351L7.32422 11.964L7.70808 11.9084L7.87982 11.5605Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/usd.0d6254cca5c09b378130b1fec5aeb796.svg";
export { ForwardRef as ReactComponent };